import React from "react";
import PropTypes from "prop-types";

import { Collapse, Row, Col, Well } from "react-bootstrap";
import Formsy from "formsy-react";
import { useSelector } from "react-redux";

const MaintenanceFiltersWrapper = ({
  loading,
  disabled,
  children,
  filtersOpen,
  onFetchClick,
  onResetClick
}) => {
  const auth = useSelector((state) => state.reducers.auth);

  return (
    <React.Fragment>
      <Collapse
        in={filtersOpen}
        className="filter-container"
        style={{
          marginLeft: 15,
          marginRight: 15,
          backgroundColor: auth.isNightMode ? "#1a2129" : "#f2f3f8",
          border: "none"
        }}
      >
        <Well>
          <Formsy className="vertical form">
            {children}
            <Row style={{ marginLeft: 0, marginBottom: 10, marginTop: 15 }}>
              <Col md={12}>
                <button
                  className="btn btn-warning"
                  type="button"
                  onClick={onResetClick}
                  disabled={loading || disabled}
                >
                  Reset
                </button>
                <button
                  className="btn btn-primary"
                  type="button"
                  onClick={onFetchClick}
                  disabled={loading || disabled}
                >
                  Fetch Data
                </button>
              </Col>
            </Row>
          </Formsy>
        </Well>
      </Collapse>
    </React.Fragment>
  );
};

MaintenanceFiltersWrapper.propTypes = {
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  children: PropTypes.node,
  filtersOpen: PropTypes.bool,
  onFetchClick: PropTypes.func,
  onResetClick: PropTypes.func
};

MaintenanceFiltersWrapper.defaultProps = {
  loading: false,
  disabled: false,
  filtersOpen: true,
  onFetchClick: () => {},
  onResetClick: () => {}
};

export default MaintenanceFiltersWrapper;
